import { ChangeDetectorRef, Component, ElementRef, inject, Input, OnChanges, OnDestroy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'timesheet-info',
  templateUrl: './timesheet-info.component.html',
})
export class TimesheetInfoComponent implements OnChanges, OnDestroy {
  private elementRef = inject(ElementRef);
  private cd = inject(ChangeDetectorRef);

  @Input()
  text: string | number | undefined;
  @Input()
  absenceWarning: boolean;
  @Input()
  doubleRegistration: boolean;
  @Input()
  deviatesFromSchedule: boolean;

  isTruncated = false;

  private checkTimeout?: ReturnType<typeof setTimeout>;

  ngOnChanges() {
    if (this.checkTimeout) {
      clearTimeout(this.checkTimeout);
    }

    // Give the .timesheet-info time to render otherwise the widths are not set.
    this.checkTimeout = setTimeout(() => {
      this.checkIfTruncated();
    }, 200);
  }

  ngOnDestroy() {
    if (this.checkTimeout) {
      clearTimeout(this.checkTimeout);
    }
  }

  private checkIfTruncated() {
    // The text, not the container around it: the container clips, but the text
    // shrinks to fit it, so only the text still reports an overflow once it has
    // been ellipsised.
    const textElement: HTMLElement | null = this.elementRef.nativeElement.querySelector('.timesheet-info-text');

    const tolerance = 2;
    const isTruncated = textElement ? textElement.offsetWidth + tolerance < textElement.scrollWidth : false;

    if (this.isTruncated !== isTruncated) {
      this.isTruncated = isTruncated;
      this.cd.markForCheck();
    }
  }
}
